import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=7961a21b&"
import script from "./ColorPicker.js?vue&type=script&lang=js&"
export * from "./ColorPicker.js?vue&type=script&lang=js&"
import style0 from "./ColorPicker.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
installComponents(component, {VCard,VCardText,VCardTitle,VColorPicker})
